import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const [loading, setLoading] = useState(true);
  const [authed, setAuthed] = useState(false);
  const [adminOk, setAdminOk] = useState(!requireAdmin);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      const { data } = await supabase.auth.getSession();
      const session = data.session;
      if (!mounted) return;
      setAuthed(Boolean(session));
      if (!session) {
        setAdminOk(false);
        setLoading(false);
        return;
      }
      if (requireAdmin) {
        try {
          const res = await fetch('/api/admin/check', {
            headers: { Authorization: `Bearer ${session.access_token}` }
          });
          setAdminOk(res.ok);
        } catch {
          setAdminOk(false);
        }
      }
      setLoading(false);
    };
    run();
    return () => { mounted = false; };
  }, [requireAdmin]);

  if (loading) return null;
  if (!authed) {
    return <Navigate to="/login" replace />;
  }

  if (!adminOk) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
